import React from 'react'
import { Row, Col, Collapse, CardBody } from "reactstrap";
import moment from "moment";
import { formatDate } from "../../../Utils/format-date.js";
import { addButton } from "../../../Utils/addButtons";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils//calculate-progress.js";
import OpPopover from "../../../Components/PopOver/Popover";
import info_black_24dp from "../../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../popover-inner-content";
import completed from "../../../../images/completed.png";
import Emptyassessment from "../empty-assessment";
import './Assessment-table.css'

    const currentDate = moment().format("YYYY-MM-DD");

const ResponsiveAssessmentDetails = (props) => {

    return (
        <React.Fragment>
            {props.userAssessmentDetails.length == 0 ? (
                <Emptyassessment />
            ) : (
                <div className='Responsive-Assessment-Details'>
                    {props.userAssessmentDetails.map((assessment, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Row className='justify-content-around'>
                                    <img
                                        className="assessmentIcon"
                                        src={
                                            localStorage.getItem("baseLink") +
                                            `/media/` +
                                            assessment.instrument__instrument_image
                                        }
                                    />
                                    <div className="assessmentName mt-0">
                                        {assessment.instrument__dashboard_header_text}
                                        <p className='responsive-assessmentName'>{assessment.participant__full_name}'s {assessment.instrument__instrument_name}</p>
                                    </div>
                                    <OpPopover
                                        positions={["left"]}
                                        align={"center"}
                                        targtElement={
                                            <img className="infoIcon" src={info_black_24dp} style={{ marginTop:'10px'}} />
                                        }
                                        isOpen={
                                            props.isPopOverOpenAssessmentId === assessment.id
                                        }
                                        setOpen={(bool) => {
                                            props.handleAssessmentPopOver(
                                                bool ? assessment.id : false
                                            );
                                        }}
                                    >
                                        <Renderpopoverinnercontent
                                            handleClosePopOver={props.handleClosePopOver}
                                            assessmentheading={
                                                assessment.instrument__dashboard_header_text
                                            }
                                            assesmentdescription={
                                                assessment.instrument__dashboard_header_description
                                            }
                                        />
                                    </OpPopover>
                                    <i onClick={() => props.toggleCollapse(assessment.id)}
                                        className={props.collapseID === assessment.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                                      aria-hidden="true"  style={{ marginTop:'10px'}} />
                                </Row>
                               
                                <hr />
                                <Collapse isOpen={props.collapseID === assessment.id}>
                                    <CardBody>
                                        <Row>
                                            <Col className='title'>Date of Expiry</Col>
                                            <Col className='details'> {formatDate(assessment.expiry_date)}</Col>
                                        </Row>
                                        <Row>
                                            <Col className='title'>Status</Col>
                                            <Col className='details'>
                                                {currentDate > assessment.expiry_date ? (
                                                    <div
                                                        className={
                                                            "assessment-status-text" +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        Expired
                                                    </div>
                                                ) : assessment.assessment_status__status_name ===
                                                    "Report in review" ? (
                                                    <div
                                                        className={
                                                            "assessment-status-text " +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        Completed
                                                        <img src={completed} alt="Completed Image" />
                                                    </div>
                                                ) : assessment.respondent_completed >=
                                                    assessment.batch__min_respondent ? (
                                                    <div
                                                        className={
                                                            "assessment-status-text " +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        Completed
                                                        <span>
                                                            ({assessment.batch__min_respondent}/
                                                            {assessment.batch__min_respondent})
                                                        </span>
                                                    </div>
                                                ) : assessment.assessment_status__status_name ===
                                                    "Yet to start" ? (
                                                    <div
                                                        className={
                                                            "assessment-status-text " +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        {assessment.assessment_status__status_name}
                                                    </div>
                                                ) : assessment.assessment_status__status_name ===
                                                    "In progress" ? (
                                                    <div
                                                        style={{ display: "flex" ,flexDirection:"column"}}
                                                        className={
                                                            "assessment-status-text assessment-status-text-inprogress " +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        {assessment.assessment_status__status_name}
                                                        {calcPercentage(
                                                            assessment.assessment_number_count,
                                                            assessment.assessment_completed_count
                                                        )}
                                                    </div>
                                                ) : assessment.respondent_completed <
                                                    assessment.batch__min_respondent ? (
                                                    <div
                                                        className={
                                                            "assessment-status-text " +
                                                            addClassName(
                                                                assessment.assessment_status__status_name
                                                            )
                                                        }
                                                    >
                                                        Completed
                                                        <span>
                                                            ({assessment.respondent_completed}/
                                                            {assessment.respondent_count})
                                                        </span>
                                                    </div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                        <Row>{addButton(assessment)}</Row>
                                        <hr />
                                    </CardBody>
                                </Collapse>
                            </React.Fragment>
                        )
                    })}
                </div>
            )}
        </React.Fragment>
    )
}

export default ResponsiveAssessmentDetails



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-assessments/Responsive/Assessment-table.jsx